import React from "react";
import Skeleton from "react-loading-skeleton";

const Skeletons = ({
  height,
  width = "100%" as any,
  baseColor = "#1F2937",
  highlightColor = "#111827",
  circle = false,
  style = {},
  ...props
}) => {
  return (
    <Skeleton
      height={height}
      width={width}
      baseColor={baseColor}
      highlightColor={highlightColor}
      style={style}
      circle={circle}
      {...props}
    />
  );
};

export default Skeletons;
